export const SET_ESTABLISHMENT_ID = 'BUSINESS_INFO/SET_ESTABLISHMENT_ID';
export const SET_PREVIOUS_ESTABLISHMENT_ID = 'BUSINESS_INFO/SET_PREVIOUS_ESTABLISHMENT_ID';
export const SET_BUSINESS_INFO = 'BUSINESS_INFO/SET_BUSINESS_INFO';
export const SET_ESTABLISHMENT_TYPES = 'BUSINESS_INFO/SET_ESTABLISHMENT_TYPES';
export const CLEAR_BUSINESS_INFO = 'BUSINESS_INFO/CLEAR_BUSINESS_INFO';
export const CLEAR_ADDRESS = 'BUSINESS_INFO/CLEAR_ADDRESS';
export const HANDLE_POSTAL_CODE = 'BUSINESS_INFO/HANDLE_POSTAL_CODE';
export const HANDLE_LOADING = 'BUSINESS_INFO/HANDLE_LOADING';
export const HANDLE_EDITING = 'BUSINESS_INFO/HANDLE_EDITING';
export const SET_ESTABLISHMENTS = 'BUSINESS_INFO/SET_ESTABLISHMENTS';